<template>
  <section :class="$style.container">
    <h2 :class="$style.title">セミナーの削除</h2>
    <section :class="$style.description">
      <p>
        こちらのセミナーは現在ほかに設定されている日程がないため、<br />
        <span :class="$style['text--emphasized']"
          >この日程を削除するとセミナー自体が削除されます。</span
        >
      </p>
      <p>
        削除された場合、再度同じセミナーを開催するには改めて申請が必要になります。<br />
        上記に同意いただける場合は、下の内容にチェックのうえ、<br />
        削除ボタンをクリックしてください。
      </p>
    </section>
    <div :class="$style.action">
      <div>
        <label :class="$style.check"
          ><DolphinCheckbox v-model="checked" /><span
            >上記を確認しました</span
          ></label
        >
      </div>
      <FlatButton
        :class="$style.action__button"
        :disabled="!checked"
        variant="caution"
        @click="emit('delete')"
      >
        このセミナーを削除
      </FlatButton>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DolphinCheckbox from '@/components/atoms/DolphinCheckbox.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'

const emit = defineEmits<{
  (event: 'delete'): void
}>()

const checked = ref(false)
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 24px;
}

.title {
  font-size: 20px;
  font-weight: bold;
}

.description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
}

.action {
  &__button {
    margin: 12px;
  }
}

.check {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.text {
  &--emphasized {
    font-weight: bold;
  }
}
</style>
